export default __webpack_public_path__ + "13cc8c11934afde08c99bca924c21f7d.png";